'use client'

import { PillBadge } from '@/components/ui/pill-badge'

const BADGE_OFFSET_PX = 10

/**
 * Wraps an auth button/input and anchors the "Last used" badge to its top-right corner.
 *
 * Deliberately NOT a `position: fixed` portal: fixed coordinates are captured against the layout
 * viewport, but when the mobile software keyboard opens, iOS pans the VISUAL viewport to reveal
 * the focused input — the wrapped control shifts on screen while the fixed badge stays put (and
 * the pan emits no window scroll/resize event to recompute from), so the badge visibly detached
 * and floated above its control. Absolutely positioning inside the wrapper means the badge cannot
 * separate from what it labels, in any viewport regime. The ~10px overhang lives comfortably
 * inside the auth steps' surrounding padding, so nothing clips it.
 */
export function AuthButtonWithLastUsedBadge({
    showBadge,
    children,
}: {
    showBadge: boolean
    children: React.ReactNode
}) {
    return (
        <div className="relative w-full">
            {children}
            {showBadge && (
                <span
                    className="pointer-events-none absolute z-100"
                    style={{ top: -BADGE_OFFSET_PX, right: -BADGE_OFFSET_PX }}
                >
                    <PillBadge label="Last used" variant="beta" />
                </span>
            )}
        </div>
    )
}
